import axiosInstance from "./AxiosConfig";
import endpoints from "./endpoints";

export const supportService = {
  supportTicketList: () =>
    axiosInstance.get(endpoints.tokenEndPoints.supportTicketList),
  getSupportTicketById: (id) =>
    axiosInstance.get(`${endpoints.tokenEndPoints.getSupportTicketById}/${id}`),
  updateSupportTicketStatus: (id, data) =>
    axiosInstance.put(`${endpoints.tokenEndPoints.updateSupportTicketStatus}/${id}`, data),
  countSupportTicketsByStatus: () =>
    axiosInstance.get(endpoints.tokenEndPoints.countSupportTicketsByStatus),
};
